// Firebase Hosting forwards /api/** to the Express function.
export const getApiBaseUrl = (configuredUrl = process.env.REACT_APP_API_URL) =>
  (configuredUrl?.trim() || '/api/v1').replace(/\/+$/, '');

export const getApiUrl = (path) =>
  `${getApiBaseUrl()}/${path.replace(/^\/+/, '')}`;
